import { render, staticRenderFns } from "./badgeadmin.vue?vue&type=template&id=3c57ca98&"
import script from "./badgeadmin.vue?vue&type=script&lang=js&"
export * from "./badgeadmin.vue?vue&type=script&lang=js&"
import style0 from "./badgeadmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports